import { SUPPORTING_EXCHANGES as SUPPORTING_EXCHANGES_CONFIG } from '@/lib/configs/exchange-registry'

export enum SUPPORTED_EXCHANGE {
  BINANCE = 'BINANCE',
  BYBIT = 'BYBIT',
  HYPERLIQUID = 'HYPERLIQUID',
  DERIBIT = 'DERIBIT',
  DERIVE = 'DERIVE',
  UPBIT = 'UPBIT',
  LIGHTER = 'LIGHTER',
  // Keyed by the venue (Toss) like every other entry, even though its market
  // data carries the exchange enum EXCHANGE_XKRX.
  TOSS = 'TOSS',
  PAPERTRADE = 'PAPERTRADE',
  // Databento market-data-only venues — no account-creation venue, so (unlike
  // every entry above) these are keyed directly by the market itself rather
  // than a broker. See lib/proto/util.ts's toExchangeEnum/toExchangeString and
  // lib/utils/account-select.ts's resolveExchangeTradeability.
  GLBX = 'GLBX',
  XNAS = 'XNAS',
  XNYS = 'XNYS',
  OPRA = 'OPRA',
}

export const SUPPORTING_EXCHANGES = SUPPORTING_EXCHANGES_CONFIG
